<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Udtable') : $t('New Udtable')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem(false)"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <h4 class="pt-5 pb-0">{{ $t("Ud values") }}</h4>
            <v-data-table
              :headers="headers"
              :items="formValues.udValues"
              :loading="loading"
              :multi-sort="true"
              class="elevation-1"
              :hide-default-footer="true"
              disable-pagination
              :footer-props="{
                'items-per-page-options': [10, 15, 50, -1]
              }"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <h4 class="pt-5 pb-0">{{ $t("Rules") }}</h4>
                  <v-spacer></v-spacer>
                  <v-btn color="red lighten-2" dark @click="createValue">
                    {{ $t("Add Ud-value") }}
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-icon small color="red" class="mr-2" @click="editValue(item)">
                  mdi-pencil
                </v-icon>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon
                  small
                  color="red"
                  class="mr-2"
                  @click="removeValue(item)"
                >
                  mdi-minus-circle-outline
                </v-icon>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" eager>
              <base-material-card
                color="primary"
                icon="mdi-account"
                :title="udValue.id ? $t('Edit Ud-value') : $t('Add Ud-value')"
                class="px-5 py-3"
              >
                <v-form
                  ref="form"
                  autocomplete="new-password"
                  lazy-validation
                  @submit.prevent="addValue"
                >
                  <v-text-field
                    v-model="udValue.glass_area_percent"
                    :label="$t('Glass Percentage')"
                    v-validate=""
                    data-vv-name="glass_area_percent"
                    :error-messages="errors.collect('glass_area_percent')"
                  ></v-text-field>
                  <v-text-field
                    v-model="udValue.ug_value"
                    type="number"
                    :label="$t('ug_value')"
                    v-validate=""
                    data-vv-name="ug_value"
                    :error-messages="errors.collect('ug_value')"
                  ></v-text-field>
                  <v-select
                    v-model="udValue.threshold_type"
                    :items="['thermally_separated', 'thermally_not_separated']"
                    :label="$t('threshold_type')"
                    data-vv-name="threshold_type"
                    :error-messages="errors.collect('threshold_type')"
                  ></v-select>
                  <v-select
                    v-model="udValue.wood_type"
                    :items="['softwood', 'hardwood']"
                    :label="$t('wood_type')"
                    data-vv-name="wood_type"
                    :error-messages="errors.collect('wood_type')"
                  ></v-select>
                  <v-text-field
                    v-model="udValue.ud_value"
                    type="number"
                    :label="$t('ud_value')"
                    v-validate=""
                    data-vv-name="ud_value"
                    :error-messages="errors.collect('ud_value')"
                  ></v-text-field>
                  <v-card-actions class="pl-0">
                    <v-btn color="primary" class="mr-4" @click="dialog = false">
                      {{ $t("back") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-4" @click="addValue">
                      {{ $t("save") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </base-material-card>
            </v-dialog>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'udTable.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem(false)">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  deleteUdValue,
  saveUdValue
} from "../shared/services";
export default {
  name: "app-udTable-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        udValues: []
      },
      permissions: [],
      loading: true,
      udValue: {
        curr_el: 0,
        glass_area_percent: 0,
        ug_value: 0,
        threshold_type: "",
        wood_type: null,
        ud_value: 0
      },
      headers: [
        { text: "Glass areas percent", value: "glass_area_percent" },
        { text: "Ug value", value: "ug_value" },
        { text: "Threshold type", value: "threshold_type" },
        { text: "Wood type", value: "wood_type" },
        { text: "Ud value", value: "ud_value" },
        { value: "edit" },
        { value: "delete" }
      ],
      dialog: false
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    computedUdValue() {
      return {
        ud_table_id: this.$route.params.id,
        ...this.udValue
      };
    }
  },
  methods: {
    getData() {
      if (this.$route.params.id) {
        this.loading = true;
        fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    async addValue() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveUdValue(
        this.udValue.id,
        this.computedUdValue,
        this.$validator
      );
      if (resp.success) {
        this.getData();
        this.dialog = false;
      }
    },
    initUdValue() {
      this.udValue = {
        curr_el: this.udValue.curr_el + 1,
        glass_area_percent: 0,
        ug_value: 0,
        threshold_type: "",
        wood_type: null,
        ud_value: 0
      };
    },
    editValue(item) {
      this.saveItem(true).then(() => {
        this.udValue = item;
        this.dialog = true;
      });
    },
    createValue() {
      this.saveItem(true).then(() => {
        this.initUdValue();
        this.dialog = true;
      });
    },
    async removeValue(item) {
      let resp = await deleteUdValue(item.id);
      if (resp.success) {
        this.getData();
        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
    },
    async saveItem(remain = false) {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        if (remain) {
          if (!this.$route.params.id) {
            this.$router.push({
              name: "udTable.edit",
              params: { id: resp.data.id }
            });
          }
          return Promise.resolve(true);
        } else {
          this.$root.$notification(resp.message, { type: "success" });
          this.$router.push({ name: "udTable.index" });
        }
      }
    }
  },
  watch: {
    dialog: {
      handler(val) {
        if (!val) this.initUdValue();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
